var waIsotopGlobalGrids = {
	// inits isotopes grid, allows to run it on any element if needed
	init: function () {
		$('.global-grid').isotope({
			itemSelector: '.global-grid-item',
			transitionDuration: 0,
			percentPosition: true,
		});
	}
};
